import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, Input, OnChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { AssessRequestRaService } from 'src/app/assess-request-ra/assess-request-ra.service';
import { groupRulesDetailsModel } from 'src/app/common/models/GroupRulesDetailsModel';
import { pureRulesDetailsModel, ruleFlags } from 'src/app/common/models/PureRuleDetailsModel';
import { recipeModel } from 'src/app/common/models/recipeDetailsModel';
import { REGULATORY_GROUPTABLE_COLUMNS, FETCH_RULES_PAGE_SIZE } from 'src/app/common/models/tableColumns';
import { DataService } from 'src/app/common/services/data.service';
import { WorklistService } from 'src/app/worklist/worklist.service';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs/operators';
import { parseCopyRuleResponse } from 'src/app/common/helpers/copy-rule-response.helper';

@Component({
  selector: 'app-conflicting-rule-template',
  templateUrl: './conflicting-rule-template.component.html',
  styleUrls: ['./conflicting-rule-template.component.scss']
})
export class ConflictingRuleTemplateComponent implements OnInit, AfterViewInit, OnChanges {
  loading = false;
  ruleDisplayName;
  activeTabGR = 'rule-detail'; activeTab = 'substance-list';
  activeTabCR = '';
  selectedRuleDetails = []; selectedRuleTypeDetails = []; sirIdsforSubstanceDetails: string[] = []; uomList = [];
  groupDetails; conflictingGroupDetails; groupDetailsInitial; selectedFunctionValue;
  ruleTypeId; ruleType; selectedRows;
  saveAndCloseClicked: boolean; saveAndAddNewBtnClicked: boolean; isAllCfSelected: boolean;
  allFns = []; subGroupDetails = []; conflictingSubGroupDetails = []; groupColumns = []; groupData = [];
  attBtnClicked = false; showGroupDetails = false; showLimit = false; showGroup = true; parallelRuleWorkflow = false; readOnlyValue = true; isAllConflictingCfSelected = false;
  selectedMarket; division; tfcPath;
  loadingMsg = 'loading...'; maxval = 'Maximum';
  maxEqualityCondition = [{ value: '<' }, { value: '<=' }];
  equalityCondition = [{ value: 'isEqual' }];
  uomVal = 0;
  uomval;
  substanceGroupData: {
    groupId;
    groupName;
    groupType;
    substanceData: any;
  };
  isContinue = true; isGroupSelected = false; cancelClicked = false; hideGroupA = false; editRuleFlow = false; viewRuleFlow = false; disableAnyForAllUsers = true;
  ruleAdded; applicableGroupRuleTypesToDisplay; saveAndAddNewDialog;
  rpc; rulesListForGroup; ruleTypeRadioSelected; rtRadioSelected;
  ruleSource = ''; validityStartDate: any = ''; validityEndDate: any = ''; ruleDescription = '';
  yearAdopted: any;
  editRuleData; ParentRuleId: any;
  targetProducts = []; sourceProducts = []; confTargetProducts = []; confSourceProducts = [];
  ruleIdOnEdit; ruleVersion; selectedRowsRelated = [];
  showRelatedRulesPopup = false; viewRelbtn = false; ruleSaveConformationPopup = false;
  prepareRuleTableData = []; myWorklistTableColumns = [];
  showEmailConfirmationDialog = false;
  commentsToUser = ''; marketForModal = '';
  ruleComment: string;
  todayDate; defaultValidityFromDate; defaultValidityEndDate; maxequalityConditionSelected;
  public readonly maxSubstanceThreshold = 800;
  @Input() subChildKey: number;
  @Input() reqData: any[] = [];
  @Input() parentRuleId: any;
  addRuleType = '';
  copyRuleResponseDialog = false;
  copyRuleSuccess = [];
  copyRuleFailure = [];
  EventType: any;
  viewRuleBtnDisableFlagContribution = false;
  filteredContributionSubGroups = [];
  contributionRows = 10;
  contributionFirst = 0;
  selectedSubstanceContribution: any = '';
  filteredContributionResult: any[] = [];
  isContributionFilterApplied = false;

  viewRuleBtnDisableFlagCombination = false;
  filteredCombinationSubGroups = [];
  combinationRows = 10;
  combinationFirst = 0;
  selectedSubstance: any = '';
  filteredCombinationResult: any[] = [];
  isCombinationFilterApplied = false;
  selectedConflictingGroupSubstanceCount = 0;
  isAllRelatedRequestsChecked = false;
  constructor(
    private assessReqRAdataService: AssessRequestRaService, public snackBarGroup: MatSnackBar, public formBuilder: FormBuilder,
    public dataSvcObj: DataService, private datePipe: DatePipe, private worklistservice: WorklistService, private route: Router) { }
  /* istanbul ignore next */
  ngOnChanges(): void {
    this.addRuleType = this.reqData.length && this.reqData[0].AddRuleType ? this.reqData[0].AddRuleType : '';
    this.resetComponent();
    this.ParentRuleId = this.parentRuleId;
  }
  ngAfterViewInit(): void {
    this.disableCheckbox(0);
  }
  disableCheckbox(i) {
    if (this.dataSvcObj.isfromSubstancesearch) {
      const picklistSource = document.getElementsByClassName('ui-picklist-source-wrapper').item(i) as HTMLElement;
      if (picklistSource) {
        picklistSource.style.display = 'none';
        const picklistButton = document.getElementsByClassName('ui-picklist-buttons').item(i) as HTMLElement;
        picklistButton.style.display = 'none';
        const picklistTarget = document.getElementsByClassName('ui-picklist-target-wrapper').item(i) as HTMLElement;
        picklistTarget.style.cssFloat = 'left';
      }
    }
  }
  private parseNumericCfValue(rawValue) {
    if (rawValue === null || rawValue === undefined) {
      return null;
    }
    const valueText = rawValue.toString();
    const cfPatternMatch = valueText.match(/CF\s*:\s*(-?\d+(\.\d+)?)/i);
    if (cfPatternMatch) {
      return Number(cfPatternMatch[1]);
    }
    const match = valueText.match(/-?\d+(\.\d+)?/);
    return match ? Number(match[0]) : null;
  }

  private getNearestCfOption(cfDetails, cfInputData) {
    if (!cfDetails || cfDetails.length === 0) {
      return null;
    }

    const inputValue = this.parseNumericCfValue(cfInputData);
    if (inputValue === null) {
      return cfDetails[0];
    }

    let nearest = null;
    let minDiff = Number.MAX_VALUE;
    cfDetails.forEach((detail) => {
      const detailValue = this.parseNumericCfValue(detail && (detail.cf !== undefined ? detail.cf : detail.cfDisplayText));
      if (detailValue !== null) {
        const diff = Math.abs(detailValue - inputValue);
        if (diff < minDiff) {
          minDiff = diff;
          nearest = detail;
        }
      }
    });

    return nearest || cfDetails[0];
  }

  private applyDefaultContributionFactor(subgroup) {
    if (!subgroup || !subgroup.cfDetails || subgroup.cfDetails.length === 0) {
      return;
    }

    subgroup.selectedCF = subgroup.cfDetails.filter(x => x.cfDisplayText === subgroup.ContributionFactor)[0];
    if (!subgroup.selectedCF) {
      const nearestCf = this.getNearestCfOption(subgroup.cfDetails, subgroup.cfInputData);
      subgroup.selectedCF = nearestCf;
      subgroup.ContributionFactor = nearestCf ? nearestCf.cfDisplayText : subgroup.cfDetails[0].cfDisplayText;
    }

    if (subgroup.selectedCF) {
      subgroup.formattedCF = 'CF  ' + subgroup.selectedCF.cf;
    }
  }
  /* istanbul ignore next */
  ngOnInit() {
    if (this.addRuleType === 'Clone') {
      this.loading = true;
    }
    this.todayDate = new Date();
    this.defaultValidityFromDate = this.datePipe.transform(this.todayDate, 'longDate');
    this.defaultValidityEndDate = this.datePipe.transform(new Date('9999-12-31'), 'longDate');
    this.editRuleFlow = false;
    this.viewRuleFlow = false;
    if (this.activeTabGR === 'rule-detail') {
      document.getElementById('description').style.display = 'none';
    }
    this.dataSvcObj.getruleToEdit().subscribe((value) => {
      if (value !== null) {
        this.editRuleFlow = true;
        this.viewRelbtn = false;
        this.marketForModal = recipeModel.marketDetails.marketName;
        this.editRuleData = value;
        this.ruleDisplayName = value.ruleType;
        this.ruleTypeId = value.ruleTypeID;
        this.ruleSource = value.ruleSource;
        if (ruleFlags.viewRule) {
          this.defaultValidityFromDate = value.validityStartDate ? (this.datePipe.transform(new Date(this.datePipe.transform(value.validityStartDate, 'yyyy-MM-dd')), 'longDate')) : '';
          this.defaultValidityEndDate = value.validityDate ? (this.datePipe.transform(new Date(this.datePipe.transform(value.validityDate, 'yyyy-MM-dd')), 'longDate')) : '';
        }
        this.applyCloneValidity();
        this.yearAdopted = value.yearAdopted ? (new Date(value.yearAdopted)).toUTCString() : '';
        this.ruleIdOnEdit = value.ruleId;
        this.ruleVersion = value.ruleVersion;
        this.selectedFunctionValue = value.groupFunction;
        pureRulesDetailsModel.Market = value.markets[0];
        const rpcVals = [];
        value.rpcs.forEach((val) => {
          const data = {
            id: val.rpcId,
            text: val.rpcName,
            rpcFullText: val.rpcFullText
          };
          rpcVals.push(data);
        });
        pureRulesDetailsModel.selectedParentRpcs = rpcVals;
        pureRulesDetailsModel.selectedRpcs = rpcVals;
        recipeModel.preparationMethod = value.preparationMethod;
        recipeModel.intendedUse = value.intendedUse;
        this.getWorklistColumns();
      } else {
        this.editRuleFlow = false;
      }
    });
    this.groupColumns = REGULATORY_GROUPTABLE_COLUMNS;
    this.division = recipeModel.division;
    this.dataSvcObj.getGroupData.subscribe((groupData: any) => {
      this.groupDetailsInitial = JSON.parse(JSON.stringify(groupData || {}));
      if (this.editRuleFlow || this.viewRuleFlow) {
        this.groupDetails = JSON.parse(JSON.stringify(this.groupDetailsInitial || {}));
        const data = groupData.substanceData;
        this.sourceProducts = [];
        this.targetProducts = [];
        for (let i = 0; i < data.length; i++) {
          for (let j = 0; j < this.editRuleData.substanceSubgroupsToSirList.length; j++) {
            if (data[i].sirId === this.editRuleData.substanceSubgroupsToSirList[j].substanceId) {
              const val = data[i].cfDetails.filter(x => x.cf === this.editRuleData.substanceSubgroupsToSirList[j].contributionFactor)[0];
              data[i].ContributionFactor = val.cfDisplayText;
              data[i].selectedCF = val;
              data[i].formattedCF = 'CF  ' + data[i].selectedCF.cf;
              this.targetProducts.push(data[i]);
            }
          }
        }
        this.sourceProducts = _.xor(data, this.targetProducts);
        if (this.sourceProducts.length > 0 && this.editRuleFlow && (this.sourceProducts.length + this.targetProducts.length > this.maxSubstanceThreshold)) {
          this.targetProducts = _.concat(this.targetProducts, this.sourceProducts);
          this.sourceProducts = [];
        }
        this.subGroupDetails = this.targetProducts;

        this.conflictingGroupDetails = Object.assign({}, groupData.conflictingGroupData[0]);
        this.getFnList();
        const data2 = groupData.conflictingGroupData[0].substanceData;
        this.confSourceProducts = [];
        this.confTargetProducts = [];
        for (let i = 0; i < data2.length; i++) {
          for (let j = 0; j < this.editRuleData.conflictingSubstanceSubgroupsToSirList.length; j++) {
            if (data2[i].sirId === this.editRuleData.conflictingSubstanceSubgroupsToSirList[j].substanceId) {
              const val = data2[i].cfDetails.filter(x => x.cf === this.editRuleData.conflictingSubstanceSubgroupsToSirList[j].contributionFactor)[0];
              data2[i].ContributionFactor = val.cfDisplayText;
              data2[i].selectedCF = val;
              data2[i].formattedCF = 'CF  ' + data2[i].selectedCF.cf;
              this.confTargetProducts.push(data2[i]);
            }
          }
        }
        this.confSourceProducts = _.xor(data2, this.confTargetProducts);
        if (this.confSourceProducts.length > 0 && this.editRuleFlow && (this.confSourceProducts.length + this.confTargetProducts.length > this.maxSubstanceThreshold)) {
          this.confTargetProducts = _.concat(this.confTargetProducts, this.confSourceProducts);
          this.confSourceProducts = [];
        }
        this.conflictingSubGroupDetails = this.confTargetProducts;
        if (this.addRuleType === 'Clone') {
          setTimeout(() => this.loading = false);
        }
      } else {
        this.refreshTemplate();
        this.groupDetailsInitial = JSON.parse(JSON.stringify(groupData || {}));
        this.groupDetails = JSON.parse(JSON.stringify(this.groupDetailsInitial || {}));
        if (this.groupDetails.substanceData.length > this.maxSubstanceThreshold) {
          this.subGroupDetails = this.groupDetails.substanceData;
        }
      }
    });
    this.dataSvcObj.getSelectedGroupRuleType.subscribe((value) => {
      if (value.length !== 0) {
        this.selectedRuleTypeDetails[0] = value;
        this.ruleTypeId = this.selectedRuleTypeDetails[0].ruleTypeId;
        this.ruleDisplayName = this.selectedRuleTypeDetails[0].ruleTypeDisplayName;
        this.activeTabGR = 'rule-detail';
        document.getElementById('rule-detail').style.display = 'block';
        document.getElementById('description').style.display = 'none';
        this.ruleDescription = this.selectedRuleTypeDetails[0].ruleTypeDescription ? this.selectedRuleTypeDetails[0].ruleTypeDescription : null;
        this.getGroupDetail();
        this.getFnList();
        if (!this.editRuleFlow && !this.viewRuleFlow) {
          const fullSource = (this.groupDetailsInitial && this.groupDetailsInitial.substanceData)
            ? JSON.parse(JSON.stringify(this.groupDetailsInitial.substanceData))
            : [];
          this.sourceProducts = fullSource;
          this.targetProducts = [];
          this.subGroupDetails = [];
          this.groupDetails = JSON.parse(JSON.stringify(this.groupDetailsInitial || {}));
          this.activeTabCR = '';
          if (this.groupDetails.substanceData.length > this.maxSubstanceThreshold) {
            this.subGroupDetails = this.groupDetails.substanceData;
          }
          this.ruleSource = '';
          this.validityStartDate = '';
          this.validityEndDate = '';
          this.yearAdopted = '';
          this.groupData = [];
        }
      }
    });
    if (ruleFlags.viewRule) {
      this.editRuleFlow = false;
      this.viewRuleFlow = true;
    } else if (ruleFlags.editRule) {
      this.editRuleFlow = true;
      this.viewRuleFlow = false;
    }
  }
  /* istanbul ignore next */
  resetComponent() {
    this.editRuleFlow = ruleFlags.editRule;
    this.viewRuleFlow = ruleFlags.viewRule;
  }
  /* overrides the source rule's validity dates with the dates chosen on the clone screen */
  private applyCloneValidity(): void {
    const cloneRule = this.reqData && this.reqData[0];
    if (!cloneRule) {
      return;
    }
    if (cloneRule.ValidFrom) {
      this.defaultValidityFromDate = this.datePipe.transform(new Date(cloneRule.ValidFrom), 'longDate');
    }
    if (cloneRule.ValidTo) {
      this.defaultValidityEndDate = this.datePipe.transform(new Date(cloneRule.ValidTo), 'longDate');
    }
  }
  // get group details
  getGroupDetail() {
    this.dataSvcObj.getGroupData.subscribe((groupData) => {
      this.groupDetailsInitial = JSON.parse(JSON.stringify(groupData || {}));
      this.groupDetails = JSON.parse(JSON.stringify(this.groupDetailsInitial || {}));
    });
  }
  // get function list
  /* istanbul ignore next */
  getFnList() {
    const functionApiUrl = environment.APIFAsT + '/functions';
    this.assessReqRAdataService.getData(functionApiUrl).subscribe((response) => {
      this.allFns = response;
    });
  }
  /* istanbul ignore next */
  onSaveAndClose() {
        this.loading = true;
        this.loadingMsg = 'Saving Rule';
        this.saveAndCloseClicked = true;
        setTimeout(() => {
            if (this.addRuleType === 'Clone') {
                this.EventType = 'New Rule Published';
                this.editRuleFlow = false;
                this.ParentRuleId = this.reqData[0].ruleId;
                this.ruleIdOnEdit = 0;
                const mrpc = this.reqData[0].MRPCs[0];
                pureRulesDetailsModel.Market = { marketId: mrpc.marketId, marketName: mrpc.marketName };
                const clonedRpc = [{ id: mrpc.RPCId, text: mrpc.RPCName, rpcFullText: mrpc.RPCFullText }];
                pureRulesDetailsModel.selectedParentRpcs = clonedRpc;
                pureRulesDetailsModel.selectedRpcs = clonedRpc;
            } else {
                this.EventType = this.editRuleFlow ? 'Rule Version Updated' : 'New Rule Published';
            }
            this.onSave();
        });
    }
  onSaveandAddNew() {
        this.loading = true;
        this.loadingMsg = 'Saving Rule';
        this.saveAndAddNewBtnClicked = true;
        setTimeout(() => {
            this.onSave();
        });
  }

  /* istanbul ignore next */
  onClone() {
    const payLoad = [];
    const apiUrl = environment.APIFAsTRule + '/cloneEditRule';
    payLoad.push({
      ruleId: Number(this.reqData[0].ruleId),
      ruleTypeID: Number(this.reqData[0].ruleTypeID),
      ruleVersion: this.reqData[0].ruleVersion,
      MRPCs: [
        {
          marketId: this.reqData[0].MRPCs[0].marketId,
          marketName: this.reqData[0].MRPCs[0].marketName,
          RPCId: this.reqData[0].MRPCs[0].RPCId,
          RPCName: this.reqData[0].MRPCs[0].RPCName,
          RPCFullText: this.reqData[0].MRPCs[0].RPCFullText
        }
      ]
    });
    this.assessReqRAdataService.postData(apiUrl, payLoad).pipe(take(1)).subscribe((responseData) => {
      if (responseData !== null) {
        const copyRuleResponse = parseCopyRuleResponse(responseData);
        this.copyRuleSuccess = copyRuleResponse.success;
        this.copyRuleFailure = copyRuleResponse.failure;
        if (this.copyRuleFailure.length > 0) {
          this.loading = false;
          this.copyRuleResponseDialog = true;
          return;
        }
        const cloneResponse = Array.isArray(responseData) ? responseData[0] : responseData;
        this.ruleIdOnEdit = cloneResponse.ruleId;
        this.ruleVersion = 0;
        this.EventType = 'New Rule Published';
        // onSave() reads market/RPC off pureRulesDetailsModel, so sync it with the clone's target MRPC before saving
        const mrpc = this.reqData[0].MRPCs[0];
        pureRulesDetailsModel.Market = { marketId: mrpc.marketId, marketName: mrpc.marketName };
        const clonedRpc = [{ id: mrpc.RPCId, text: mrpc.RPCName, rpcFullText: mrpc.RPCFullText }];
        pureRulesDetailsModel.selectedParentRpcs = clonedRpc;
        pureRulesDetailsModel.selectedRpcs = clonedRpc;
        this.onSave();
      }
    }, () => {
      this.loading = false;
    });
  }

  /* istanbul ignore next */
  onSave() {
    let ruleTypeId;
    let ruleType;
    const rpcData = [];
    const subgroupsubstancelist = [];
    const conflictingsubgroupsubstancelist = [];
    const mktList = [{ marketId: pureRulesDetailsModel.Market.marketId, marketName: pureRulesDetailsModel.Market.marketName }];
    ruleTypeId = this.ruleTypeId;
    ruleType = this.ruleDisplayName;

    if (groupRulesDetailsModel.CascadeRpc === 'Y') {
      pureRulesDetailsModel.selectedParentRpcs.forEach((value) => {
        const data = {
          rpcFullText: value.rpcFullText,
          rpcName: value.text,
          rpcId: value.id
        };
        rpcData.push(data);
      });
    } else {
      pureRulesDetailsModel.selectedRpcs.forEach((value) => {
        const data = {
          rpcFullText: value.rpcFullText,
          rpcName: value.text,
          rpcId: value.id
        };
        rpcData.push(data);
      });
    }
    // subgroup details for group
    this.subGroupDetails.forEach(subgroup => {
      subgroup.selectedCF = subgroup.cfDetails.filter(x => x.cfDisplayText === subgroup.ContributionFactor)[0];
      subgroupsubstancelist.push({
        SubstanceId: subgroup.sirId,
        ComponentName: subgroup.selectedCF.component,
        ContributionFactor: subgroup.selectedCF.cf,
        NumberOfExpressedAs: subgroup.selectedCF.numberOfExpressedAs,
        SubComponentMolWeight: subgroup.selectedCF.componentMolWeight,
      });
    });
    // conflicting subgroup details
    this.conflictingSubGroupDetails.forEach(conflictingsubgroup => {
      conflictingsubgroup.selectedCF = conflictingsubgroup.cfDetails.filter(x => x.cfDisplayText === conflictingsubgroup.ContributionFactor)[0];
      conflictingsubgroupsubstancelist.push({
        SubstanceId: conflictingsubgroup.sirId,
        ComponentName: conflictingsubgroup.selectedCF.component,
        ContributionFactor: conflictingsubgroup.selectedCF.cf,
        NumberOfExpressedAs: conflictingsubgroup.selectedCF.numberOfExpressedAs,
        SubComponentMolWeight: conflictingsubgroup.selectedCF.componentMolWeight,
      });
    });
    if (this.editRuleFlow || this.viewRuleFlow) {
      delete this.groupDetails.conflictingGroupData;
    }

    const savedData = [{
      RuleId: this.ruleIdOnEdit ? this.ruleIdOnEdit : 0,
      RuleVersion: this.ruleVersion ? this.ruleVersion : 0,
      ParentRuleId: this.ParentRuleId ? this.ParentRuleId : 0,
      RPCs: rpcData,
      MarketID: Number(pureRulesDetailsModel.Market.marketId),
      Market: pureRulesDetailsModel.Market.marketName,
      Markets: mktList,
      RuleTypeID: ruleTypeId,
      RuleType: ruleType,
      CascadeMarket: 'N',
      CascadeRpc: 'Y',
      UoMID: 2,
      UoM: 'N/A',
      TexualMinLimitText: '',
      TexualMaxLimitText: '',
      RuleDescription: '',
      RuleSource: this.ruleSource ? this.ruleSource : '',
      RuleSourceType: '',
      AdditionalStatement: '', // other requirements and restrictions
      PositiveStatement: '',
      MaxLimit: 0,
      MinLimit: '',
      RuleClaim: '',
      RuleSpecificCondions: '',
      GroupFunction: this.selectedFunctionValue,
      PreparationMethod: recipeModel.preparationMethod,
      IntendedUse: recipeModel.intendedUse,
      FunctionList: null, // used only for allowed function array of objects
      NegativeStatement: '',
      IsMandatorySubstance: null, // Y for substance mandatory rule
      WarningText: null, // used for warning rule, adulterated rule , phased out rule, other requirements and restrictions, Product Warnings
      SubstanceGroup: this.groupDetails,
      ConflictingSubstanceGroup: this.conflictingGroupDetails,
      SubstanceSubgroupsToSirList: subgroupsubstancelist,
      ConflictingSubstanceSubgroupsToSirList: conflictingsubgroupsubstancelist,
      yearAdopted: this.yearAdopted ? this.datePipe.transform(this.yearAdopted, 'yyyy-MM-dd') : null,
      ValidityStartDate: this.validityStartDate ? this.datePipe.transform(this.validityStartDate, 'yyyy-MM-dd') : this.datePipe.transform(this.defaultValidityFromDate, 'yyyy-MM-dd'),
      ValidityDate: this.validityEndDate ? this.datePipe.transform(this.validityEndDate, 'yyyy-MM-dd') : this.datePipe.transform(this.defaultValidityEndDate, 'yyyy-MM-dd'),
      Comments: this.ruleComment ? this.ruleComment : null,
      RuleFlow: this.parallelRuleWorkflow === true ? 'Parallel' : 'Request',
      EventType: this.EventType ? this.EventType : ''
    }];
    if (!this.editRuleFlow) {
      const saveRuleToDbUrl = environment.APIFAsTRule + '/rulesList';
      this.loading = true;
      this.assessReqRAdataService.postData(saveRuleToDbUrl, savedData).subscribe((response) => {
        this.loading = false;
        if (response[0].ruleId !== 0) {
          this.ruleAdded = response;
          this.getGroupRuleDetailsFromDb();
          this.snackBarGroup.open('Group Rule added successfully with Rule Id:' + response[0].ruleId, 'close', {
            duration: 5000,
            panelClass: ['success']
          });
          if (this.saveAndAddNewBtnClicked) {
            setTimeout(() => {
              this.dataSvcObj.getApplicableRuleTypesObsv.subscribe((res) => {
                if (res.length !== 0) {
                  pureRulesDetailsModel.applicableRuleTypeList = res;
                  this.applicableGroupRuleTypesToDisplay = res;
                }
              });
              this.applicableGroupRuleTypesToDisplay = pureRulesDetailsModel.applicableRuleTypeList;
              this.saveAndAddNewDialog = true;
              this.saveAndAddNewBtnClicked = false;
            }, 3000);
          } else if (this.addRuleType === 'Clone') {
            this.route.navigateByUrl('/home', { skipLocationChange: true }).then(() => {
              this.route.navigate(['/rule-management/view-rules']);
            });
          } else if (this.saveAndCloseClicked) {
              this.dataSvcObj.setExpandablePanel(2);
              this.saveAndCloseClicked = false;
            }
          this.refreshTemplate();
        } else {
          this.snackBarGroup.open('Rule could not be created.', 'close', {
            duration: 5000,
            panelClass: ['error']
          });
        }
      }, (error) => {
        this.loading = false;
        this.ruleTypeRadioSelected = false;
        this.rtRadioSelected = undefined;
        this.dataSvcObj.setSelectedGroupRuleType([]);
        this.dataSvcObj.setExpandablePanel(2);
        // this.handleErrors(error);
      });
    } else {
      const url = environment.APIFAsTRule + '/rules';
      this.loading = true;
      this.assessReqRAdataService.putData(url, savedData).subscribe((response) => {
        this.loading = false;
        if (response[0].ruleId !== 0) {
          this.ruleAdded = response;
          this.snackBarGroup.open('Rule updated successfully with Rule Id:' + response[0].ruleId + ' and Rule Version: ' + response[0].ruleVersion, 'close', {
            duration: 5000,
            panelClass: ['success']
          });
          this.route.navigateByUrl('/home', { skipLocationChange: true }).then(() => {
            this.route.navigate(['/rule-management/view-rules']);
          });
        } else {
          this.snackBarGroup.open('Rule could not be updated.', 'close', {
            duration: 5000,
            panelClass: ['error']
          });
        }
      }, (error) => {
        this.loading = false;
      });
    }
  }
  // get group rule details from DB
  /* istanbul ignore next */
  getGroupRuleDetailsFromDb() {
    this.rpc = [];
    if (pureRulesDetailsModel.selectedRpcs !== undefined) {
      if (pureRulesDetailsModel.selectedRpcs[0].text !== 'No Regulatory Product Class is Mapped') {
        pureRulesDetailsModel.selectedRpcs.forEach((rpcValue) => {
          this.rpc.push({
            rpcId: rpcValue.id,
            rpcName: rpcValue.text,
            rpcFullText: rpcValue.rpcFullText,
          });
        });
      }
    }
    const fetchRuleBody = {
      MarketList: [pureRulesDetailsModel.Market],
      RPCList: this.rpc,
      ruleClassifications: ['Substance Group Rules'],
      PageNumber: 1,
      PageSize: FETCH_RULES_PAGE_SIZE,
      SearchFilterJson: {RuleCategory: 'Substance Group Rules'}
    };
    this.loading = true;
    this.loadingMsg = 'Fetching data from FAST Rule-Engine';
    const getruleapiurl = environment.APIFAsTRule + '/rules/FetchRulesMaster';
    return new Promise<any>((resolve) => {
      this.assessReqRAdataService.postData(getruleapiurl, fetchRuleBody)
        .toPromise()
        .then(response => {
          this.loading = false;
          if (response !== null && response.data !== undefined && response.data.length > 0) {
            resolve(response);
            const result = response.data.filter(x => x.ruleClassification === 'Substance Group Rules');
            for (const value of result) {
              value.ruleVerionToDisplay = 'V' + value.ruleVersion;
              // if (value.cfDetails !== null && value.cfDetails !== undefined) {
              //   const cfValue = value.cfDetails;
              //   value.cf = cfValue.cf;
              //   value.cfSubstanceExpressedAs = cfValue.component;
              // }
              // value.warningText = (value.warningText !== null) ? value.warningText : ((value.warningStatement !== null) ? value.warningStatement : '');
              // if (value.warningText !== null) {
              //   value.warningTextStripped = this.handleSpecialCharacters(value.warningText);
              // } else {
              //   value.warningTextStripped = ' ';
              // }
              // value.otherRestrictionsAndRequirements = (value.otherRestrictionsAndRequirements !== null) ? value.otherRestrictionsAndRequirements : '';
              // if (value.otherRestrictionsAndRequirements !== null) {
              //   value.otherRestrictionsAndRequirementsStripped = this.handleSpecialCharacters(value.otherRestrictionsAndRequirements);
              // } else {
              //   value.otherRestrictionsAndRequirementsStripped = ' ';
              // }
            }
            this.dataSvcObj.setRulesListForGroup(result);
            groupRulesDetailsModel.rulesListForGroups = result;
            this.rulesListForGroup.push(result.filter((value) => value.groupID === this.groupDetails.groupId));
          }
        }).catch(error => {
          this.loading = false;
        });
    });
  }
  handleSpecialCharacters(text) {
    return text.replace(/<.*?>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;.*?/gi, '').replace(/&amp;/g, '&');
  }
  /* istanbul ignore next */
  onAddAttributeBtnClicked() {
    this.attBtnClicked = !this.attBtnClicked;
  }
  /* istanbul ignore next */
  onCancel() {
    if (!this.editRuleFlow) {
      this.refreshTemplate();
      this.dataSvcObj.setExpandablePanel(2);
    } else {
      this.route.navigateByUrl('/home', { skipLocationChange: true }).then(() => {
        this.route.navigate(['/rule-management/view-rules']);
      });
    }
  }
  /* istanbul ignore next */
  onNextButtonClick(tabname) {
    this.activeTab = tabname;
    if (tabname === 'contribution-factor') {
      if (this.editRuleFlow || this.viewRuleFlow) {
        this.showGroup = true;
        this.subGroupDetails = this.targetProducts;
        this.subGroupDetails.forEach((subgroup) => {
          if (!subgroup.ContributionFactor) {
            if (subgroup.cfDetails && subgroup.cfDetails.length > 0) {
              subgroup.ContributionFactor = subgroup.cfDetails[0].cfDisplayText;
            }
          }
        });
      }
      if (!this.editRuleFlow && !this.viewRuleFlow) {
        this.subGroupDetails.forEach((subgroup) => {
          this.applyDefaultContributionFactor(subgroup);
        });
      }
    }
    if (tabname === 'contribution-factor-B') {
      if (this.editRuleFlow || this.viewRuleFlow) {
        this.conflictingSubGroupDetails = this.confTargetProducts;
        this.conflictingSubGroupDetails.forEach((subgroup) => {
          if (!subgroup.ContributionFactor) {
            if (subgroup.cfDetails && subgroup.cfDetails.length > 0) {
              subgroup.ContributionFactor = subgroup.cfDetails[0].cfDisplayText;
            }
          }
        });
      }
      if (!this.editRuleFlow && !this.viewRuleFlow) {
        this.conflictingSubGroupDetails.forEach((subgroup) => {
          this.applyDefaultContributionFactor(subgroup);
        });
      }
      this.isAllConflictingCfSelected = true;
    }
  }
  /* istanbul ignore next */
  onTabChange(activeTab) {
    this.activeTabGR = activeTab;
    if (activeTab === 'rule-detail') {
      this.hideGroupA = false;
      this.activeTabGR = 'rule-detail';
      if (this.conflictingSubGroupDetails.length === 0 && !this.showLimit) {
        this.activeTab = 'substance-list';
        document.getElementById('rule-detail').style.display = 'block';
        document.getElementById('rule-detail-B').style.display = 'none';
      } else {
        this.activeTab = 'substance-list-B';
        this.activeTabGR = 'rule-detail-B';
        this.showLimit = true;
        this.activeTabCR = 'rule-detail-B';
        document.getElementById('rule-detail').style.display = 'none';
        if (document.getElementById('rule-detail-B') !== null) {
          document.getElementById('rule-detail-B').style.display = 'block';
        }
      }
      document.getElementById('description').style.display = 'none';
      document.getElementById('ruleValidity').style.display = 'none';
    } else if (activeTab === 'description') {
      this.hideGroupA = true;
      document.getElementById('rule-detail').style.display = 'none';
      document.getElementById('description').style.display = 'block';
      document.getElementById('ruleValidity').style.display = 'none';
      if (document.getElementById('rule-detail-B') !== null) {
        document.getElementById('rule-detail-B').style.display = 'none';
      }
    } else if (activeTab === 'ruleValidity') {
      this.hideGroupA = true;
      document.getElementById('rule-detail').style.display = 'none';
      if (document.getElementById('rule-detail-B') !== null) {
        document.getElementById('rule-detail-B').style.display = 'none';
      }
      document.getElementById('description').style.display = 'none';
      document.getElementById('ruleValidity').style.display = 'block';
    }
    setTimeout(() => {
      this.disableCheckbox(0);
    }, 10);

  }
  /* istanbul ignore next */
  parseDate(dateString) {
    if (dateString) {
      return new Date(dateString);
    }
    return null;
  }
  // tab change for group
  /* istanbul ignore next */
  onInnerTabChange(activeTab) {
    this.activeTab = activeTab;
    // setting default contribution factor
    if (activeTab === 'contribution-factor') {
      if (this.editRuleFlow || this.viewRuleFlow) {
        this.showGroup = true;
        this.subGroupDetails = this.targetProducts;
        this.subGroupDetails.forEach((subgroup) => {
          if (!subgroup.ContributionFactor) {
            if (subgroup.cfDetails && subgroup.cfDetails.length > 0) {
              subgroup.ContributionFactor = subgroup.cfDetails[0].cfDisplayText;
            }
          }
        });
      }
      if (!this.editRuleFlow && !this.viewRuleFlow) {
        this.subGroupDetails.forEach((subgroup) => {
          this.applyDefaultContributionFactor(subgroup);
        });
      }
      if (this.subGroupDetails.length < this.maxSubstanceThreshold) {
        this.contributionRows = this.subGroupDetails.length;
      } else {
        this.contributionRows = 10;
      }

    }
  }
  // tab change for conflicting group
  /* istanbul ignore next */
  onInnerTabChangeB(activeTab) {
    this.activeTab = activeTab;
    if (activeTab === 'contribution-factor-B') {
      if (this.editRuleFlow || this.viewRuleFlow) {
        this.conflictingSubGroupDetails = this.confTargetProducts;
        this.conflictingSubGroupDetails.forEach((consubgroup) => {
          if (!consubgroup.ContributionFactor) {
            if (consubgroup.cfDetails && consubgroup.cfDetails.length > 0) {
              consubgroup.ContributionFactor = consubgroup.cfDetails[0].cfDisplayText;
            }
          }
        });
      }
      if (!this.editRuleFlow && !this.viewRuleFlow) {
        this.conflictingSubGroupDetails.forEach((consubgroup) => {
          this.applyDefaultContributionFactor(consubgroup);
        });
        this.isAllConflictingCfSelected = true;
      }
      if (this.conflictingSubGroupDetails.length < this.maxSubstanceThreshold) {
        this.combinationRows = this.conflictingSubGroupDetails.length;
      } else {
        this.combinationRows = 10;
      }
    }
  }
  // group list for selecting conflicting group
  /* istanbul ignore next */
  openGroupDetails() {
    this.isContinue = true;
    this.isGroupSelected = false;
    this.showGroupDetails = true;
    this.conflictingSubGroupDetails = [];
    this.selectedConflictingGroupSubstanceCount = 0;
    if (!this.groupData || this.groupData.length === 0) {
      this.getGroups();
    }
    this.getUomList();
  }
  // get groups
  /* istanbul ignore next */
  getGroups() {
    this.loading = true;

    const apiurl = environment.APIFAsTRule + '/rules/substancegroups/masterlist/getgroupsbyfilters'
      + '?UPDFullText=' + encodeURIComponent(this.division)
      + '&GroupType=' + encodeURIComponent('Regulatory Group');
    this.assessReqRAdataService.getData(apiurl).subscribe((response) => {
      this.groupData = [];
      if (response) {
        const groups = Array.isArray(response) ? response : [];
        groups.forEach(group => {
          const substanceIds = Array.isArray(group.substanceIds) ? group.substanceIds : [];
          const substances = Array.isArray(group.substances)
            ? group.substances
            : (Array.isArray(group.substanceData) ? group.substanceData : []);
          const groupSubstanceCount = Number(group && (
            group.substanceCount || group.totalSubstanceCount || group.substancesCount
            || group.substanceCnt || group.totalCount || substanceIds.length || substances.length
          )) || 0;
          const groupDataLengthBeforeMap = this.groupData.length;

          substanceIds.forEach(sub => {
            const temp = [];
            substances.forEach(element => {
              if (element.sirId === sub) {
                const elementCfDetails = Array.isArray(element.cfDetails) ? element.cfDetails : [];
                elementCfDetails.forEach(cf => {
                  temp.push(cf.cfDisplayText);
                });
                this.groupData.push({
                  groupId: group.groupId,
                  groupName: group.groupName,
                  groupType: group.groupType,
                  createdDate: group.createdDate,
                  createdByUserIdDisplayName: group.createdByUserIdDisplayName,
                  modifiedDate: group.modifiedDate,
                  modifiedByUserIdDisplayName: group.modifiedByUserIdDisplayName,
                  substanceCount: groupSubstanceCount,
                  substanceId: sub,
                  pureCode: element.pureCode,
                  pureDescription: element.pureDescription,
                  substanceName: element.substanceName,
                  cas: element.cas,
                  parentCAS: element.parentCAS,
                  cfDetails: elementCfDetails,
                  cfData: temp.toString(),
                  ins: element.ins,
                  inciName: element.inciName,
                  einecs: element.einecs,
                  cfInputData: element.cfInputData,
                });
              }
            });
          });

          // New masterlist response can be group-level only without nested substances.
          // Add one table row so the group still appears in Choose Group popup.
          if (this.groupData.length === groupDataLengthBeforeMap) {
            this.groupData.push({
              groupId: group.groupId,
              groupName: group.groupName,
              groupType: group.groupType,
              createdDate: group.createdDate,
              createdByUserIdDisplayName: group.createdByUserIdDisplayName,
              modifiedDate: group.modifiedDate,
              modifiedByUserIdDisplayName: group.modifiedByUserIdDisplayName,
              substanceCount: groupSubstanceCount,
              substanceId: null,
              pureCode: null,
              pureDescription: null,
              substanceName: null,
              cas: null,
              parentCAS: null,
              cfDetails: [],
              cfData: '',
              ins: null,
              inciName: null,
              einecs: null,
              cfInputData: null,
            });
          }
        });
        const seenGroupIds = new Set();
        this.groupData.forEach(row => {
          row.show = !seenGroupIds.has(row.groupId);
          seenGroupIds.add(row.groupId);
        });
        this.loading = false;
      } else {
        this.loading = false;
      }
    }, (error) => {
      this.loading = false;
    });
  }
  /* istanbul ignore next */
  continue() {
    if (!this.isGroupSelected && (!this.editRuleFlow && !this.viewRuleFlow)) {
      return;
    }
    this.showGroupDetails = false;
    this.showLimit = true;
    this.activeTabGR = '';
    this.activeTab = 'substance-list-B';
    this.activeTabCR = 'rule-detail-B';
    if (document.getElementById('rule-detail') !== null) {
      document.getElementById('rule-detail').style.display = 'none';
    }
    if (document.getElementById('rule-detail-B') !== null) {
      document.getElementById('rule-detail-B').style.display = 'block';
    }
    setTimeout(() => {
      this.disableCheckbox(1);
    }, 10);

  }
  // remove conflicting group
  /* istanbul ignore next */
  removeGroupB() {
    this.showLimit = false;
    this.activeTab = 'substance-list';
    this.activeTabGR = 'rule-detail';
    this.activeTabCR = '';
    this.isAllConflictingCfSelected = false;
    this.hideGroupA = false;
    this.conflictingSubGroupDetails = [];
    document.getElementById('rule-detail').style.display = 'block';
    document.getElementById('description').style.display = 'none';
  }
  // select CF for group
  /* istanbul ignore next */
  onCfSelect() {
    let isSelected;
    this.subGroupDetails.forEach(subgroup => {
      if (!subgroup.ContributionFactor) {
        isSelected = true;
      }
    });
    if (!isSelected) {
      this.isAllCfSelected = true;
    }
  }
  // select cf for conflicting group
  /* istanbul ignore next */
  onConflictingCfSelect() {
    let isSelected;
    this.conflictingSubGroupDetails.forEach(subgroup => {
      if (!subgroup.ContributionFactor) {
        isSelected = true;
      }
    });
    if (!isSelected) {
      this.isAllConflictingCfSelected = true;
    }
  }
  /* istanbul ignore next */
  getUomList() {
    if (this.uomList && this.uomList.length > 0) {
      return;
    }
    const url = environment.APIFAsT + '/uoms';
    this.assessReqRAdataService.getData(url).subscribe((response) => {
      if (response !== null) {
        this.uomList = response;
      }
    });
  }
  /* istanbul ignore next */
  onGroupSelect(rowValue) {
    this.conflictingSubGroupDetails = [];
    this.isContinue = false;
    this.isGroupSelected = false;
    this.substanceGroupData = {
      groupId: rowValue.groupId,
      groupName: rowValue.groupName,
      groupType: rowValue.groupType,
      substanceData: []
    };
    const groupRows = this.groupData.filter(groupsub => groupsub.groupId === rowValue.groupId && groupsub.substanceId);
    const selectedGroupCount = Number(rowValue && (
      rowValue.substanceCount || rowValue.totalSubstanceCount || rowValue.substancesCount
      || rowValue.substanceCnt || rowValue.totalCount || groupRows.length
    )) || 0;
    this.selectedConflictingGroupSubstanceCount = selectedGroupCount;
    // Align with RG Master flow: treat radio selection as immediate selection,
    // then hydrate substances from API when needed.
    this.conflictingGroupDetails = Object.assign({}, this.substanceGroupData);
    // this.isGroupSelected = true;
    groupRows.forEach(groupsub => {
      const subData = {
        sirId: groupsub.substanceId,
        pureCode: groupsub.pureCode,
        substanceName: this.changeToTitleCase(groupsub.substanceName),
        cas: groupsub.cas,
        parentCAS: groupsub.parentCAS,
        inciName: groupsub.inciName,
        ins: groupsub.ins,
        cfDetails: groupsub.cfDetails,
        cfInputData: groupsub.cfInputData
      };
      this.substanceGroupData.substanceData.push(subData);
    });

    // For masterlist responses that only return group headers, fetch full group details.
    // if (!this.substanceGroupData.substanceData || this.substanceGroupData.substanceData.length === 0) {
    this.loading = true;
    this.loadingMsg = 'Loading group substances...';
    const encodedGroupType = encodeURIComponent(rowValue.groupType || 'Regulatory Group');
    const encodedDivision = encodeURIComponent(this.division || '');
    const viewGroupApiUrl = environment.APIFAsTRule + '/rules/substancegroups/viewgroup/'
      + rowValue.groupId + '/' + encodedGroupType + '/' + encodedDivision;

    this.assessReqRAdataService.getData(viewGroupApiUrl).subscribe((response: any) => {
      const viewGroupResponse = Array.isArray(response) ? response[0] : response;
      const substances = viewGroupResponse && Array.isArray(viewGroupResponse.substances)
        ? viewGroupResponse.substances : [];

      this.substanceGroupData.substanceData = [];
      substances.forEach((element) => {
        this.substanceGroupData.substanceData.push({
          sirId: element.sirId || element.substanceId || element.id,
          pureCode: element.pureCode,
          substanceName: this.changeToTitleCase(element.substanceName),
          cas: element.cas,
          parentCAS: element.parentCAS,
          inciName: element.inciName,
          ins: element.ins,
          cfDetails: Array.isArray(element.cfDetails) ? element.cfDetails : [],
          cfInputData: element.cfInputData
        });
      });
      this.selectedConflictingGroupSubstanceCount = this.substanceGroupData.substanceData.length;

      this.conflictingGroupDetails = Object.assign({}, this.substanceGroupData);
      if (this.conflictingGroupDetails.substanceData.length > this.maxSubstanceThreshold) {
        this.conflictingSubGroupDetails = this.conflictingGroupDetails.substanceData;
      }
      this.loading = false;
      this.isGroupSelected = this.conflictingGroupDetails.substanceData.length > 0;
      this.isContinue = !this.isGroupSelected;
    }, () => {
      this.loading = false;
      this.isGroupSelected = false;
      this.isContinue = true;
    });
    // return;
    // }

    // this.conflictingGroupDetails = Object.assign({}, this.substanceGroupData);
    // if (this.conflictingGroupDetails.substanceData.length > this.maxSubstanceThreshold) {
    //   this.conflictingSubGroupDetails = this.conflictingGroupDetails.substanceData;
    // }
    // this.isGroupSelected = true;
  }
  /* istanbul ignore next */
  changeToTitleCase(word: string) {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }
  /* istanbul ignore next */
  ruleTypeRadioButtonChanged(event) {
    this.ruleTypeRadioSelected = true;
    this.rtRadioSelected = event.target.value;
  }
  /* istanbul ignore next */
  onContinue() {
    if (this.rtRadioSelected !== undefined) {
      const obj = _.filter(pureRulesDetailsModel.applicableRuleTypeList, (element) => element.ruleTypeDisplayName === this.rtRadioSelected);
      // tslint:disable-next-line: no-shadowed-variable
      const obj1 = obj.reduce((obj, newObj, i) => {
        newObj[i] = obj;
        return newObj;
      }, {});
      this.saveAndAddNewDialog = false;
      this.dataSvcObj.setSelectedGroupRuleType(obj1);
      this.dataSvcObj.setExpandablePanel(3);
    }
  }
  // refresh template
  /* istanbul ignore next */
  refreshTemplate() {
    this.subGroupDetails.forEach((element, indexcount) => {
      if (indexcount === 0) {
        this.groupDetails.substanceData = [];
      }
      this.groupDetails.substanceData.push(element);
    });
    this.conflictingSubGroupDetails.forEach((element, indexcount) => {
      if (indexcount === 0) {
        this.conflictingGroupDetails.substanceData = [];
      }
      this.conflictingGroupDetails.substanceData.push(element);
    });
    this.subGroupDetails = [];
    this.conflictingSubGroupDetails = [];
    this.showLimit = false;
    this.activeTab = 'substance-list';
    this.activeTabGR = 'rule-detail';
    this.activeTabCR = '';
    this.groupData = [];
  }
  /* istanbul ignore next */
  dateValidity(val: any) {
    const data = val.target.value;
    const d = new Date(data);
    if (!!d.valueOf()) {
      const year = d.getFullYear();
      const len = year.toString().length;
      if (len > 3) {
        val.preventDefault();
      }
    }
  }
  /* istanbul ignore next */
  onClickedOutside() {
    this.attBtnClicked = false;
  }
  /* istanbul ignore next */
  checkRulesAvail() {
    this.viewRelbtn = true;
    this.prepareRuleTableData = [];
    this.selectedRowsRelated = [];
    this.isAllRelatedRequestsChecked = false;
    this.selectedRows = null;
    this.loadingMsg = 'Fetching data from FAsT Rule-Engine';
    this.loading = true;
    const apiurl = environment.APIFAsTRule + '/rules/queryrelatedrequests';
    const body = [];
    this.showRelatedRulesPopup = true;
    body.push({
      RuleId: this.ruleIdOnEdit,
      RuleVersion: this.ruleVersion
    });
    this.assessReqRAdataService.postData(apiurl, body).subscribe((response) => {
      if (response) {
        this.loading = false;
        this.prepareRuleTableData = response.map(ruleReqElem => {
          return {
            requestDisplayID: ruleReqElem.requestDisplayID,
            cucCode: ruleReqElem.cucCode,
            cucDescription: ruleReqElem.cucDescription,
            recipeType: ruleReqElem.recipeType,
            recipeStatus: ruleReqElem.recipeStatus,
            marketId: ruleReqElem.market.marketId,
            marketName: ruleReqElem.market.marketName,
            division: (ruleReqElem.tfc.tfcLevel === 5) ? ruleReqElem.tfc.parentTFC.parentTFC.parentTFC.parentTFC.tfcName : ruleReqElem.tfc.parentTFC.parentTFC.parentTFC.tfcName,
            rDFormulationCategory: (ruleReqElem.tfc.tfcLevel === 5) ? ruleReqElem.tfc.parentTFC.parentTFC.parentTFC.tfcName : ruleReqElem.tfc.parentTFC.parentTFC.tfcName,
            formulationType: (ruleReqElem.tfc.tfcLevel === 5) ? ruleReqElem.tfc.parentTFC.parentTFC.tfcName : ruleReqElem.tfc.parentTFC.tfcName,
            formulationClass: (ruleReqElem.tfc.tfcLevel === 5) ? ruleReqElem.tfc.parentTFC.tfcName : ruleReqElem.tfc.tfcName,
            formulationSubClass: (ruleReqElem.tfc.tfcLevel === 5) ? ruleReqElem.tfc.tfcName : '',
            preparationMethod: ruleReqElem.preparationMethod,
            intendedUse: ruleReqElem.intendedUse,
            multicomponent: ruleReqElem.isMultiComponent,
            requestStatus: ruleReqElem.requestStatus,
            ra: ruleReqElem.ra,
            allRa: ruleReqElem.allRA,
            submittedDate: ruleReqElem.submittedDate,
            submittedByUserId: ruleReqElem.submittedByUserId,
            submittedByUserName: ruleReqElem.submittedByUserName,
            comments: ruleReqElem.comments,
            assignedDate: ruleReqElem.assignedDate,
            inProgressRADate: ruleReqElem.inProgressRADate,
            inProgressRDDate: ruleReqElem.inProgressRNDDate,
            inProgressSIRDate: ruleReqElem.inProgressSIRDate,
            rejectedDate: ruleReqElem.rejectedDate,
            deletionDate: ruleReqElem.deletionDate,
            completedDate: ruleReqElem.completedDate,
            rdComment: ruleReqElem.comments,
            raComment: ruleReqElem.raComment,
            topTfcId: ruleReqElem.tfcid,
            allRAIDs: ruleReqElem.allRAIDs,
            raUserID: ruleReqElem.raUserIDred,
            divisionid: (ruleReqElem.tfc.tfcLevel === 5) ? ruleReqElem.tfc.parentTFC.parentTFC.parentTFC.parentTFC.tfcId : ruleReqElem.tfc.parentTFC.parentTFC.parentTFC.tfcId,
            isRelatedRequestChecked: false
          };
        });
      }
      const ele = document.getElementById('echeck') as HTMLInputElement;
      ele.checked = false;
      this.selectedRowsRelated = [];
    }, (error) => {
      this.loading = false;
    });
  }
  /* istanbul ignore next */
  getWorklistColumns() {
    const apiurl = environment.APIFAsT + '/getworklistcolumns/relatedrequest';
    this.worklistservice.getWorklistApiData(apiurl).subscribe((response) => {
      this.myWorklistTableColumns = response;
    });
  }
  /* istanbul ignore next */
  sendEmail() {
    this.showEmailConfirmationDialog = true;
    let reqId = '';
    let userDetails = '';
    const uDetail = [];
    const reDet = [];
    this.selectedRowsRelated.forEach(element => {
      reDet.push(element.requestDisplayID);
    });
    const distinctReqs = reDet.filter((n, i) => reDet.indexOf(n) === i);
    reqId = distinctReqs.join(' ');
    this.selectedRowsRelated.forEach(element => {
      uDetail.push(element.ra);
    });
    const distinctNames = uDetail.filter((n, i) => uDetail.indexOf(n) === i);
    userDetails = distinctNames.join(' ');
    this.commentsToUser = 'Regulatory rule/s for the request no. ' + reqId + ' will be updated/deleted by RA user ' + userDetails + ' .To get the most updated FAsT report, please submit a new request for the formulation. Ignore if the formulation is no longer valid.';
  }
  /* istanbul ignore next */
  sendEmailMessage() {
    const payLoad = {
      NotificationGroup: 'RDCOMPLETED',
      Subject: 'FAsT | Rules updated for these requests :',
      EmailBody: null,
      ToEmailList: '',
      FromEmail: null,
      CCEmailList: null,
      EmailType: 'html',
      UPD: this.ruleIdOnEdit.toString(),
      PureCodes: null,
      UserRequests: [],
      CUCDescription: null,
      Comments: this.commentsToUser
    };

    if (this.selectedRowsRelated.length > 0) {
      this.selectedRowsRelated.forEach(row => {
        const reqIds = this.selectedRowsRelated.filter(item => item.submittedByUserId === row.submittedByUserId).map(i => i.requestDisplayID);
        payLoad.UserRequests.push({
          userId: +row.submittedByUserId,
          requestIds: reqIds
        });
      });
    }

    if (payLoad.UserRequests.length > 0) {
      this.assessReqRAdataService.sendRulesEmailNotification(payLoad);
    }
    this.showEmailConfirmationDialog = false;
    this.showRelatedRulesPopup = false;
  }
  /* istanbul ignore next */
  onGroupSelectPopup(checkValue) {
    if (checkValue) {
      this.selectedRowsRelated = this.prepareRuleTableData;
    } else {
      this.selectedRowsRelated = [];
    }
  }
  get totalSubstanceCount(): number {
    if (!this.editRuleFlow && !this.viewRuleFlow) {
      const groupSubstanceCount = this.groupDetails && this.groupDetails.substanceData ? this.groupDetails.substanceData.length : 0;
      const subGroupSubstanceCount = this.subGroupDetails ? this.subGroupDetails.length : 0;
      return groupSubstanceCount + subGroupSubstanceCount;
    }
    if (this.editRuleFlow || this.viewRuleFlow) {
      const sourceCount = this.sourceProducts ? this.sourceProducts.length : 0;
      const targetCount = this.targetProducts ? this.targetProducts.length : 0;
      return sourceCount + targetCount;
    }
  }

  get showAllSubstancesMessage(): boolean {
    return this.totalSubstanceCount > this.maxSubstanceThreshold;
  }

  openGroupLink(): void {
    const groupId = this.groupDetails ? (this.groupDetails.groupId || this.groupDetails.id) : null;
    const groupName = this.groupDetails ? this.groupDetails.groupName : '';
    const groupType = this.groupDetails ? this.groupDetails.groupType : 'Regulatory Group';
    const division = recipeModel.division ? recipeModel.division : this.division;

    if (!groupId) {
      this.snackBarGroup.open('Group details are not available.', 'close', {
        duration: 2500,
        panelClass: ['error']
      });
      return;
    }

    const urlTree = this.route.createUrlTree(
      ['/administration/regulatory-group-master/view-group', groupId],
      {
        queryParams: {
          groupName: groupName || '',
          groupType: groupType || 'Regulatory Group',
          division: division || '',
          backbuttonflag: false
        }
      }
    );
    const url = this.route.serializeUrl(urlTree);
    const openedWindow = window.open(url, '_blank');
    if (!openedWindow) {
      this.snackBarGroup.open('Pop-up blocked. Please allow pop-ups and try again.', 'close', {
        duration: 3500,
        panelClass: ['error']
      });
    }
  }
  get totalSubstanceCount_conflict(): number {
    if (!this.editRuleFlow && !this.viewRuleFlow) {
      const groupSubstanceCount = this.conflictingGroupDetails && this.conflictingGroupDetails.substanceData ? this.conflictingGroupDetails.substanceData.length : 0;
      const subGroupSubstanceCount = this.conflictingSubGroupDetails ? this.conflictingSubGroupDetails.length : 0;
      if (groupSubstanceCount === 0 && subGroupSubstanceCount === 0 && this.selectedConflictingGroupSubstanceCount > 0) {
        return this.selectedConflictingGroupSubstanceCount;
      }
      return groupSubstanceCount + subGroupSubstanceCount;
    }
    if (this.editRuleFlow || this.viewRuleFlow) {
      const sourceCount = this.confSourceProducts ? this.confSourceProducts.length : 0;
      const targetCount = this.confTargetProducts ? this.confTargetProducts.length : 0;
      return sourceCount + targetCount;
    }
  }
  get showAllConflictingSubstancesMessage(): boolean {
    return this.totalSubstanceCount_conflict > this.maxSubstanceThreshold;
  }
  openGroupLink_conflict(): void {
    const groupId = this.conflictingGroupDetails ? (this.conflictingGroupDetails.groupId || this.conflictingGroupDetails.id) : null;
    const groupName = this.conflictingGroupDetails ? this.conflictingGroupDetails.groupName : '';
    const groupType = this.conflictingGroupDetails ? this.conflictingGroupDetails.groupType : 'Regulatory Group';
    const division = recipeModel.division ? recipeModel.division : this.division;

    if (!groupId) {
      this.snackBarGroup.open('Conflicting group details are not available.', 'close', {
        duration: 2500,
        panelClass: ['error']
      });
      return;
    }

    const urlTree = this.route.createUrlTree(
      ['/administration/regulatory-group-master/view-group', groupId],
      {
        queryParams: {
          groupName: groupName || '',
          groupType: groupType || 'Regulatory Group',
          division: division || '',
          backbuttonflag: false
        }
      }
    );
    const url = this.route.serializeUrl(urlTree);
    const openedWindow = window.open(url, '_blank');
    if (!openedWindow) {
      this.snackBarGroup.open('Pop-up blocked. Please allow pop-ups and try again.', 'close', {
        duration: 3500,
        panelClass: ['error']
      });
    }
  }

  openConflictingGroupLink(rowData: any, event?: Event): void {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    const groupId = rowData ? rowData.groupId : null;
    const groupName = rowData ? rowData.groupName : '';
    const groupType = rowData ? rowData.groupType : 'Regulatory Group';
    const division = recipeModel.division ? recipeModel.division : this.division;

    const urlTree = this.route.createUrlTree(
      ['/administration/regulatory-group-master/view-group', groupId],
      {
        queryParams: {
          groupName: groupName || '',
          groupType: groupType || 'Regulatory Group',
          division: division || '',
          backbuttonflag: false
        }
      }
    );
    const url = this.route.serializeUrl(urlTree);
    const openedWindow = window.open(url, '_blank');
    if (!openedWindow) {
      this.snackBarGroup.open('Pop-up blocked. Please allow pop-ups and try again.', 'close', {
        duration: 3500,
        panelClass: ['error']
      });
    }
  }

  get contributionSubGroupsPaged() {
        const source = this.contributionDisplaySource || [];
        const first = Math.max(0, this.contributionFirst || 0);
        const rows = Math.max(1, this.contributionRows || 10);
        return source.slice(first, first + rows);
    }

    get contributionDisplayFirst() {
        return Math.max(0, this.contributionFirst || 0);
    }

  onContributionPageChange(event: any) {
    this.contributionFirst = event.first;
    this.contributionRows = event.rows;
  }
  get contributionDisplaySource() {
    if (!this.editRuleFlow && !this.viewRuleFlow) {
      if (this.subGroupDetails.length < this.maxSubstanceThreshold) {
        return (this.subGroupDetails || []).filter((item: any) =>
          item &&
          item.cfDetails &&
          item.cfDetails.length > 1
        ) || [];
      }
      return this.isContributionFilterApplied
        ? this.filteredContributionResult
        : (this.subGroupDetails || []).filter((item: any) =>
          item &&
          item.cfDetails &&
          item.cfDetails.length > 1
        ) || [];
    }
    if (this.editRuleFlow || this.viewRuleFlow) {
      if (this.subGroupDetails.length < this.maxSubstanceThreshold) {
        return (this.subGroupDetails || []).filter((item: any) =>
          item &&
          item.cfDetails &&
          item.cfDetails.length > 1
        ) || [];
      }
      return this.isContributionFilterApplied
        ? this.filteredContributionResult
        : (this.subGroupDetails || []).filter((item: any) =>
          item &&
          item.cfDetails &&
          item.cfDetails.length > 1
        ) || [];
    }
  }
  viewResultContribution() {
    const term = this.getSelectedSubstanceName_Contribution().toLowerCase();
    this.contributionFirst = 0;

    if (!term) {
      this.filteredContributionResult = [];
      this.isContributionFilterApplied = false;
      return;
    }
    if (!this.editRuleFlow && !this.viewRuleFlow) {
      this.filteredContributionResult = (this.subGroupDetails || []).filter((item: any) =>
        item &&
        item.cfDetails &&
        item.cfDetails.length > 1 &&
        String(item && item.substanceName ? item.substanceName : '').toLowerCase() === term
      );
    }
    if (this.editRuleFlow || this.viewRuleFlow) {
      this.filteredContributionResult = (this.subGroupDetails || []).filter((item: any) =>
        item &&
        item.cfDetails &&
        item.cfDetails.length > 1 &&
        String(item && item.substanceName ? item.substanceName : '').toLowerCase() === term
      );
    }
    this.isContributionFilterApplied = true;
  }
  searchSubstance_contribution(event: any) {
    const query = String(event && event.query ? event.query : '').toLowerCase();
    if (!this.editRuleFlow && !this.viewRuleFlow) {
      const source = this.subGroupDetails || [];
      this.filteredContributionSubGroups = source.filter((item: any) =>
        item &&
        item.cfDetails &&
        item.cfDetails.length > 1 &&
        String(item && item.substanceName ? item.substanceName : '').toLowerCase().includes(query)
      );
    }
    if (this.editRuleFlow || this.viewRuleFlow) {
      const sourceProduct = this.subGroupDetails || [];
      this.filteredContributionSubGroups = sourceProduct.filter((item: any) =>
        item &&
        item.cfDetails &&
        item.cfDetails.length > 1 &&
        String(item && item.substanceName ? item.substanceName : '').toLowerCase().includes(query)
      );
    }

  }
  clearSubstance_contribution() {
    this.selectedSubstanceContribution = null;
    this.filteredContributionSubGroups = [];
    this.filteredContributionResult = [];
    this.isContributionFilterApplied = false;
    this.viewRuleBtnDisableFlagContribution = true;
    this.contributionFirst = 0;
  }
  onContributionSubstanceInputChange(): void {
    this.viewRuleBtnDisableFlagContribution = !this.isContributionSubstanceSelected();
  }
  substanceSelected_contribution(val: any): void {
    const selectedSubstanceName = this.getSelectedSubstanceName_Contribution(val);
    this.selectedSubstanceContribution = this.buildSubstanceSelection(selectedSubstanceName);
    this.viewRuleBtnDisableFlagContribution = !selectedSubstanceName;
    if (selectedSubstanceName) {
      this.viewResultContribution();
    }
  }
  isContributionSubstanceSelected(): boolean {
    const currentValue = this.selectedSubstanceContribution;
    const selectedValue = this.getSelectedSubstanceName_Contribution().toLowerCase();

    if (!selectedValue || !currentValue || typeof currentValue !== 'object') {
      return false;
    }

    const exactMatches = (this.subGroupDetails || []).filter((item: any) =>
      item &&
      item.cfDetails &&
      item.cfDetails.length > 1 &&
      String(item && item.substanceName ? item.substanceName : '').toLowerCase() === selectedValue
    );

    return exactMatches.length === 1;
  }
  private getSelectedSubstanceName_Contribution(source?: any): string {
    const value = source !== undefined ? source : this.selectedSubstanceContribution;
    return String(
      value.substanceName ||
      value ||
      ''
    ).trim();
  }
  private buildSubstanceSelection(subsName: string): any {
    const normalizedsubstanceName = String(subsName || '').trim();
    if (!normalizedsubstanceName) {
      return '';
    }

    const matchedSubstance = (this.subGroupDetails || []).find((item: any) =>
      item && item.substanceName && String(item.substanceName).toLowerCase() === normalizedsubstanceName.toLowerCase()
    );

    return matchedSubstance || { substanceName: normalizedsubstanceName };
  }
  get combinationSubGroupsPaged() {
    const source = this.combinationDisplaySource || [];
    const first = Math.max(0, this.combinationFirst || 0);
    const rows = Math.max(1, this.combinationRows || 10);
    return source.slice(first, first + rows);
  }

  get combinationDisplayFirst() {
    return Math.max(0, this.combinationFirst || 0);
  }

  onCombinationPageChange(event: any) {
    this.combinationFirst = event.first;
    this.combinationRows = event.rows;
  }
  get combinationDisplaySource() {
    if (!this.editRuleFlow && !this.viewRuleFlow) {
      if (this.conflictingSubGroupDetails.length < this.maxSubstanceThreshold) {
        return (this.conflictingSubGroupDetails || []).filter((item: any) =>
          item &&
          item.cfDetails &&
          item.cfDetails.length > 1
        ) || [];
      }
      return this.isCombinationFilterApplied
        ? this.filteredCombinationResult
        : (this.conflictingSubGroupDetails || []).filter((item: any) =>
          item &&
          item.cfDetails &&
          item.cfDetails.length > 1
        ) || [];
    }
    if (this.editRuleFlow || this.viewRuleFlow) {
      if (this.conflictingSubGroupDetails.length < this.maxSubstanceThreshold) {
        return (this.conflictingSubGroupDetails || []).filter((item: any) =>
          item &&
          item.cfDetails &&
          item.cfDetails.length > 1
        ) || [];
      }
      return this.isCombinationFilterApplied
        ? this.filteredCombinationResult
        : (this.conflictingSubGroupDetails || []).filter((item: any) =>
          item &&
          item.cfDetails &&
          item.cfDetails.length > 1
        ) || [];
    }
  }
  viewResultCombination() {
    const term = this.getSelectedSubstanceName().toLowerCase();
    this.combinationFirst = 0;

    if (!term) {
      this.filteredCombinationResult = [];
      this.isCombinationFilterApplied = false;
      return;
    }

    if (!this.editRuleFlow && !this.viewRuleFlow) {
      this.filteredCombinationResult = (this.conflictingSubGroupDetails || []).filter((item: any) =>
        item &&
        item.cfDetails &&
        item.cfDetails.length > 1 &&
        String(item && item.substanceName ? item.substanceName : '').toLowerCase() === term
      );
    }
    if (this.editRuleFlow || this.viewRuleFlow) {
      this.filteredCombinationResult = (this.conflictingSubGroupDetails || []).filter((item: any) =>
        item &&
        item.cfDetails &&
        item.cfDetails.length > 1 &&
        String(item && item.substanceName ? item.substanceName : '').toLowerCase() === term
      );
    }
    this.isCombinationFilterApplied = true;
  }
  searchSubstance(event: any) {
    const query = String(event && event.query ? event.query : '').toLowerCase();
    const source = this.conflictingSubGroupDetails || [];
    this.filteredCombinationSubGroups = source.filter((item: any) =>
      item &&
        item.cfDetails &&
        item.cfDetails.length > 1 &&
        String(item && item.substanceName ? item.substanceName : '').toLowerCase().includes(query)
    );
  }
  clearSubstance() {
    this.selectedSubstance = null;
    this.filteredCombinationSubGroups = [];
    this.filteredCombinationResult = [];
    this.isCombinationFilterApplied = false;
    this.viewRuleBtnDisableFlagCombination = true;
    this.combinationFirst = 0;
  }
  onCombinationSubstanceInputChange(): void {
    this.viewRuleBtnDisableFlagCombination = !this.isCombinationSubstanceSelected();
  }
  substanceSelected(val: any): void {
    const selectedSubstanceName = this.getSelectedSubstanceName(val);
    this.selectedSubstance = this.buildSubstanceSelection(selectedSubstanceName);
    this.viewRuleBtnDisableFlagCombination = !selectedSubstanceName;
    if (selectedSubstanceName) {
      this.viewResultCombination();
    }
  }
  isCombinationSubstanceSelected(): boolean {
    const currentValue = this.selectedSubstance;
    const selectedValue = this.getSelectedSubstanceName().toLowerCase();

    if (!selectedValue || !currentValue || typeof currentValue !== 'object') {
      return false;
    }

    const exactMatches = (this.conflictingSubGroupDetails || []).filter((item: any) =>
      item &&
      item.cfDetails &&
      item.cfDetails.length > 1 &&
      String(item && item.substanceName ? item.substanceName : '').toLowerCase() === selectedValue
    );

    return exactMatches.length === 1;
  }
  private getSelectedSubstanceName(source?: any): string {
    const value = source !== undefined ? source : this.selectedSubstance;
    return String(
      value.substanceName ||
      value ||
      ''
    ).trim();
  }
  selectRowEmail(checkValue: boolean) {
    const isChecked = !!checkValue;
    this.isAllRelatedRequestsChecked = isChecked;
    (this.prepareRuleTableData || []).forEach((row: any) => {
      row.isRelatedRequestChecked = isChecked;
    });
    this.selectedRowsRelated = isChecked ? [...(this.prepareRuleTableData || [])] : [];
  }

  onAllRelatedRequestSelect(event: any) {
    const isChecked = !!(event && event.target && event.target.checked);
    this.selectRowEmail(isChecked);
  }

  onRelatedRequestSelectionChange() {
    const rows = this.prepareRuleTableData || [];
    this.selectedRowsRelated = rows.filter((row: any) => !!row.isRelatedRequestChecked);
    this.isAllRelatedRequestsChecked = rows.length > 0 && this.selectedRowsRelated.length === rows.length;
  }
}
